module.exports = __webpack_public_path__ + "static/media/chief-Collaborative.308fef03.png";